import { render, staticRenderFns } from "./SendStreetLightRequest.vue?vue&type=template&id=0c1408a7"
import script from "./SendStreetLightRequest.vue?vue&type=script&lang=ts"
export * from "./SendStreetLightRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports